import PropTypes from "prop-types";
import { Container, Box, Stack, Typography } from "@mui/material";
import { CheckCircle, Cancel } from "@mui/icons-material";

import ActionButton from "../account/ActionButton";
import ArrangementConfirmationInfoCard from "./ArrangementConfirmationInfoCard";

import { useArrangement } from "../../context/ArrangementProvider";
import ScrollToTop from "../nav/ScrollToTop";

/** 
 * The repayment plan confirmation page
 * */
function ArrangementConfirmation({ activeStep, steps, saveSuccess }) {

  const { planMode } = useArrangement();

  return (
    <>
      <ScrollToTop />
      <Stack
        sx={{
          mt: 2,
          mb: 5,
        }}
        spacing={2}
        direction={{
          xs: "column",
          md: "row",
        }}
      >
        <Box
          id='payment-plan-container'
          sx={{ width: "100%", textAlign: "center", pt: 2, pb: 4 }}
        >
          {saveSuccess ? (
            <>
              <CheckCircle color='success' sx={{ fontSize: "82px", mb: 4 }} />
              <Typography marginBottom={1} fontWeight={600} variant='h5' gutterBottom>Payment plan confirmed</Typography>
              <Typography marginBottom={4} variant='subtitle1' gutterBottom>
                {planMode === "create"
                  ? "Thank you for setting up your repayment plan. Please see the details of your new arrangement."
                  : "Thank you for updating your repayment"}
              </Typography>
            </>
          ) : (
            <>
              <Cancel sx={{ fontSize: "82px", mb: 4, color: 'error' }} />
              <Typography marginBottom={1} fontWeight={600} variant='h5' gutterBottom>Save failed</Typography>
              <Typography variant='subtitle1' gutterBottom>
                It looks like we couldn't update your repayment plan.
              </Typography>
              <Typography marginBottom={2} variant='subtitle1' gutterBottom>
                Please double check your plan details and try again when you are ready.
              </Typography>
              <Typography marginBottom={4} variant='body2' gutterBottom>
                If the issue persists, feel free to contact our support team for assistance.
              </Typography>
            </>
          )}

          <Container sx={{ py: 2 }}>
            {
              activeStep === steps.length - 1 && (
                <ActionButton
                  id='return-home-btn'
                  buttonColor='primary.dark'
                  buttonTextColor='primary.contrastText'
                  buttonTitle='Return home'
                  hoverColor='primary.light'
                  hoverTextColor='primary.dark'
                  target='/'
                />
              )
            }
          </Container>
        </Box>

        {saveSuccess && (
          <Box sx={{ width: "100%" }}>
            <ArrangementConfirmationInfoCard />
          </Box>
        )}
      </Stack>
    </>
  );
}

ArrangementConfirmation.propTypes = {
  activeStep: PropTypes.number.isRequired,
  steps: PropTypes.array.isRequired,
  saveSuccess: PropTypes.bool.isRequired,
};

export default ArrangementConfirmation;
